import Axios from 'axios';
export const getPage = {
    bySlug : async (slug)=>{

        const resp = await Axios.get(`/api/articles/${slug}`);
        return resp.data;
    },
};
